import { Employee } from '../../../../domain/employees/employee';

import TextField from '../../../shared/components/forms/TextField';

interface Props {
    employee: Employee;
    onChange: (name: string, value: string | number | boolean) => void;
}

export default function ContactInformationSection({
    employee,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='my-3'>Contacto</h5>
            <div className='col-6'>
                <TextField
                    label='Correo electrónico *'
                    name='email'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.email}
                    key='email'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Teléfono'
                    name='phoneNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.phoneNumber}
                    key='phoneNumber'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Celular'
                    name='cellphoneNumber'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.cellphoneNumber}
                    key='cellphoneNumber'
                />
            </div>
            <div className='col-6'>
                <TextField
                    label='Dirección'
                    name='address'
                    onChange={handleInputChange}
                    required={false}
                    value={employee.address}
                    key='address'
                />
            </div>
        </>
    );
}
